<template>
    <div class="challenge-results-stat-correctness">
        <span class="challenge-results-stat-correctness__value">{{ statCorrectness }}%</span>
        <span class="challenge-results-stat-correctness__label">DOĞRULUK</span>
        <div class="challenge-results-stat-correctness__progressbar">
            <span
                class="challenge-results-stat-correctness__progressbar-indicator"
                :style="indicatorStyle"></span>
        </div>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            statCorrectness: {
                type: Number,
                default: 33,
            },
        },

        computed: {
            indicatorStyle(){
                let progressbarWidth = 128;
                let indicatorWidth = (progressbarWidth / 100) * this.statCorrectness;
                return `width: ${indicatorWidth}px;`;
            }
        }
    };
</script>

<style scoped src="@/css/components/challenge-results-stat-correctness.css"></style>